import { render, staticRenderFns } from "./CareerDetail.vue?vue&type=template&id=1b72cae2&scoped=true&"
import script from "./CareerDetail.vue?vue&type=script&lang=js&"
export * from "./CareerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72cae2",
  null
  
)

export default component.exports